export default "<div class='imagen-modal'>\n\t\n\t\n</div>";